<template>
  <pnet-validation-observer>
    <div>
      <div v-if="label" class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>
              <small>{{label}}</small>
            </label>
            <div class="form-row">
              <div class="col-1" v-if="onLeft">
                <pnet-input
                  input-class="form-control text-left"
                  label-class="text-left"
                  layout="vertical"
                  v-model="field.valueSign"
                  :name="label+'Sign'"
                  :disabled="readonly"
                ></pnet-input>
              </div>
              <div class="col-11">
                <pnet-input
                  input-class="form-control text-left"
                  label-class="text-left"
                  layout="vertical"
                  v-model="field.value"
                  :rules="{required:true}"
                  :customMessages="{required:'Il campo deve essere valorizzato.'}"
                  :name="label"
                  :disabled="readonly"
                ></pnet-input>
              </div>
              <div class="col-1" v-if="!onLeft">
                <pnet-input
                  input-class="form-control text-left"
                  label-class="text-left"
                  layout="vertical"
                  v-model="field.valueSign"
                  :name="label+'Sign'"
                  :disabled="readonly"
                ></pnet-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!label">
        <div class="form-row">
          <div class="col-1" v-if="onLeft">
            <pnet-input
              input-class="form-control text-left"
              label-class="text-left"
              layout="vertical"
              v-model="field.valueSign"
              :rules="{required:false}"
              :name="'sign'"
              :disabled="readonly"
            ></pnet-input>
          </div>
          <div class="col-11">
            <pnet-input
              input-class="form-control text-left"
              label-class="text-left"
              layout="vertical"
              v-model="field.value"
              :rules="{required:true}"
              :customMessages="{required:'Il campo deve essere valorizzato.'}"
              :name="'value'"
              :disabled="readonly"
            ></pnet-input>
          </div>
          <div class="col-1" v-if="!onLeft">
            <pnet-input
              input-class="form-control text-left"
              label-class="text-left"
              layout="vertical"
              v-model="field.valueSign"
              :rules="{required:false}"
              :name="'sign'"
              :disabled="readonly"
            ></pnet-input>
          </div>
        </div>
      </div>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
import { PnetInput } from "@previnet/vue-input";
export default Vue.extend({
  props: ["label", "value", "readonly", "signOnLeft"],
  components:{
    PnetInput,
  },
  data: function() {
    return {
      field: {
        value: "",
        valueSign: "%",
      },
      onLeft: false,
    }
  },
  methods: {},
  mounted() {
    this.field = this.value;
    if (this.$props.signOnLeft !== undefined) {
      this.onLeft = this.$props.signOnLeft;
    }
  },
  watch: {
    field: {
      deep:true,
      handler(){
        this.$emit('input', this.field);
      }
    },
    value: {
      deep:true,
      immediate: true,
      handler(){
        this.field = this.value;
      }
    }
  }
});
</script>
